import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  * {\n    box-sizing: border-box;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
/* eslint-disable no-console */


import React, { Profiler, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { theme } from "../../theme";
import { textStyles } from "../../components/Text";
import { Box } from "../../components/Box";
import { baseFontStyles } from "../../theme/fonts";
import normalize from 'styled-normalize';
import { Stack } from "../../components/Stack";
import { Switch } from "../../components/Toggle";
export function Artboard(_ref) {
  var _ref$min = _ref.min,
      min = _ref$min === void 0 ? '400px' : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? '1fr' : _ref$max,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'centered' : _ref$variant,
      other = _objectWithoutProperties(_ref, ["min", "max", "variant"]);

  return /*#__PURE__*/React.createElement(StyledArtboard, _extends({
    $columns: variant === 'columns',
    $centered: variant === 'centered',
    $min: variant === 'centered' ? '1fr' : min,
    $max: max
  }, other));
}
var StyledArtboard = styled.div.withConfig({
  displayName: "Artboard__StyledArtboard",
  componentId: "vapor__sc-1hlleca-0"
})(["display:grid;grid-gap:", ";box-sizing:border-box;grid-template-columns:repeat( auto-fill,minmax(", ") );grid-auto-rows:1fr;", " ", " ", ""], theme.spaces[4], function (p) {
  return "".concat(p.$min, ", ").concat(p.$max);
}, function (p) {
  return p.$columns && "\n    height: 100vh;\n    & > * {\n      height: 100vh;\n    }\n  ";
}, function (p) {
  return p.$centered && "\n    min-height: 100vh;\n  ";
}, function (p) {
  return !p.$centered && !p.$columns && "\n    &:before {\n    content: '';\n    width: 0;\n    padding-bottom: 100%;\n    grid-row: 1 / 1;\n    grid-column: 1 / 1;\n  }\n\n  & > *:first-child {\n    grid-row: 1 / 1;\n    grid-column: 1 / 1;\n  }\n\n  ";
});
/**
 * Entity
 */

export function Entity(_ref2) {
  var _ref2$backgroundColor = _ref2.backgroundColor,
      backgroundColor = _ref2$backgroundColor === void 0 ? 'grey10' : _ref2$backgroundColor,
      _ref2$centered = _ref2.centered,
      centered = _ref2$centered === void 0 ? true : _ref2$centered,
      label = _ref2.label,
      children = _ref2.children,
      other = _objectWithoutProperties(_ref2, ["backgroundColor", "centered", "label", "children"]);

  return /*#__PURE__*/React.createElement(StyledEntity, _extends({
    $centered: centered,
    backgroundColor: backgroundColor
  }, other), label && /*#__PURE__*/React.createElement(EntityLabel, null, label), children);
}
var EntityLabel = styled.div.withConfig({
  displayName: "Artboard__EntityLabel",
  componentId: "vapor__sc-1hlleca-1"
})(["", ";color:", ";position:absolute;top:", ";left:", ";"], textStyles.secondary, theme.colors.palette.grey60, theme.spaces[12], theme.spaces[12]);
var StyledEntity = styled(Box).withConfig({
  displayName: "Artboard__StyledEntity",
  componentId: "vapor__sc-1hlleca-2"
})(["position:relative;", ""], function (p) {
  return p.$centered && "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n  ";
});
/**
 * Placeholder
 */

export var Placeholder = styled(Box).withConfig({
  displayName: "Artboard__Placeholder",
  componentId: "vapor__sc-1hlleca-3"
})(["background-color:", ";width:", ";height:", ";color:", ";text-align:center;display:flex;align-items:center;justify-content:center;"], function (p) {
  var _theme$colors$palette;

  return (_theme$colors$palette = theme.colors.palette[p.backgroundColor]) !== null && _theme$colors$palette !== void 0 ? _theme$colors$palette : theme.colors.palette.grey15;
}, function (p) {
  return p.width || '100%';
}, function (p) {
  return p.height || '30px';
}, theme.colors.palette.grey100);
/**
 * Dots for triggering things like popovers
 */

var DotHitArea = styled.button.withConfig({
  displayName: "Artboard__DotHitArea",
  componentId: "vapor__sc-1hlleca-4"
})(["display:flex;justify-content:center;align-items:center;position:absolute;padding:0;border:none;background:none;transition:all 0.4s cubic-bezier(0.54,1.5,0.38,1.2);cursor:pointer;outline:0;will-change:transform;-webkit-tap-highlight-color:transparent;border-radius:50%;&:active > div{background:rgba(0,0,0,0.1);}&:focus{box-shadow:inset 0 0 0 2px rgba(255,255,255,0.05);}&[aria-expanded='true']{box-shadow:0 0 0 4px rgba(255,255,255,0.05);}&[data-placement^='top']{top:0;left:50%;margin-left:-25px;}&[data-placement^='bottom']{bottom:0;left:50%;margin-left:-25px;}&[data-placement='top-start'],&[data-placement='bottom-start']{left:calc(50% - 50px);}&[data-placement='top-end'],&[data-placement='bottom-end']{left:calc(50% + 50px);}&[data-placement^='right']{right:0;top:50%;margin-top:-25px;}&[data-placement^='left']{left:0;top:50%;margin-top:-25px;}&[data-placement='left-start'],&[data-placement='right-start']{top:calc(50% - 50px);}&[data-placement='left-end'],&[data-placement='right-end']{top:calc(50% + 50px);}&[aria-expanded='true'] > div{background:rgba(0,0,0,0.2);}"]);
var StyledDot = styled.div.withConfig({
  displayName: "Artboard__StyledDot",
  componentId: "vapor__sc-1hlleca-5"
})(["width:30px;height:30px;border:2px solid ", ";border-radius:50%;transition:all 0.125s cubic-bezier(0.4,0,0,1);"], theme.colors.palette.grey50);
export var Dot = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(DotHitArea, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(StyledDot, null));
});
export var DotContainer = styled.div.withConfig({
  displayName: "Artboard__DotContainer",
  componentId: "vapor__sc-1hlleca-6"
})(["margin:0 auto;width:300px;height:300px;position:relative;"]);
/**
 * Documentation blocks
 */

export var testBackgroundColors = {
  light: '#D4D8E1',
  dark: '#20222B'
};
export var BlockStyles = styled.div.withConfig({
  displayName: "Artboard__BlockStyles",
  componentId: "vapor__sc-1hlleca-7"
})(["", ";"], baseFontStyles);
export var DocumentationStyles = createGlobalStyle(_templateObject(), normalize);
export var DocumentationBlock = function DocumentationBlock(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement(BlockStyles, null, /*#__PURE__*/React.createElement(Box, {
    borderRadius: 8,
    backgroundColor: "grey05",
    padding: 24
  }, children));
};
/**
 * A convenience wrapper which makes it easier
 * to test the render speed of components.
 */

export var MountProfiler = function MountProfiler(_ref4) {
  var id = _ref4.id,
      children = _ref4.children,
      _ref4$minHeight = _ref4.minHeight,
      minHeight = _ref4$minHeight === void 0 ? '400px' : _ref4$minHeight,
      _ref4$minWidth = _ref4.minWidth,
      minWidth = _ref4$minWidth === void 0 ? '300px' : _ref4$minWidth;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  return /*#__PURE__*/React.createElement(Box, {
    padding: 32
  }, /*#__PURE__*/React.createElement(Stack, {
    alignX: "center",
    gap: 16
  }, /*#__PURE__*/React.createElement(Switch, {
    label: "Toggle",
    checked: checked,
    onChange: function onChange() {
      return setChecked(!checked);
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: minHeight,
      minWidth: minWidth
    }
  }, checked && /*#__PURE__*/React.createElement(Profiler, {
    id: id,
    onRender: console.table
  }, children))));
};
export var SimulateHeavyRender = function SimulateHeavyRender(_ref5) {
  var _ref5$iterations = _ref5.iterations,
      iterations = _ref5$iterations === void 0 ? 3000 : _ref5$iterations,
      Component = _ref5.Component;
  return /*#__PURE__*/React.createElement(React.Fragment, null, _toConsumableArray(new Array(iterations)).map(function (_, i) {
    return Component ? /*#__PURE__*/React.createElement(Component, {
      key: i
    }) : /*#__PURE__*/React.createElement("div", {
      key: i
    });
  }));
};